module.exports = __webpack_public_path__ + "img/mon.c854eb97.png";